var map = {
	"./BANCCOR.png": 2896,
	"./Nespresso.png": 4800,
	"./P. F. Changs.png": 9952,
	"./Pin_Morado.png": 4928,
	"./Pin_amarillo.png": 3663,
	"./amia.png": 5860,
	"./burger.png": 6632,
	"./carp.png": 1562,
	"./colorshop.png": 3983,
	"./consultorio.png": 3185,
	"./consultorio_old.png": 175,
	"./default.png": 7553,
	"./escuela.png": 6946,
	"./espumeria.png": 5407,
	"./galicia.png": 5488,
	"./hogar.png": 2309,
	"./miscelaneo.png": 3418,
	"./museo_moderno.png": 4466,
	"./restaurant.png": 8889,
	"./santander.png": 1386,
	"./search.png": 1456,
	"./starbucks.png": 8682
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 8223;